import styled from "styled-components";
import { TRCell, } from "../shared";
import { Text, } from "@bracket/ui/components";
import { getTabularRasaStore, type RasaColumnOptions, } from "../RasaStore";
import { RasaSortIcon, } from "../RasaSortIcon";
import type { FlexAlignment, } from "@bracket/ui/types";


export declare type RasaHeaderCellProps<T extends Record<string, any>> = RasaColumnOptions<T> & {
	id: string;
	field: any;
}



export const RasaHeaderCell = <T extends Record<string, any>>(props: RasaHeaderCellProps<T> ) => {

	const { id, field, ...params } = props;
	const { columnKeys, } = getTabularRasaStore(id)();
	const column = columnKeys.get(field);

	if(!column) return <Text> - </Text>;

	return (
		<HeaderCell {...params}>
			<Text bold>{ column.label || field }</Text>
			{ column.sortable && <RasaSortIcon field={field} column={column} id={id}  /> }
		</HeaderCell>
	);
};

const HeaderCell = styled(TRCell)<{ $justify?: FlexAlignment; }>`
	justify-content: ${({ $justify }) => $justify ? $justify : "center"};
`;
